<div class="item-container flex flex-col gap-2">
  <div class="flex flex-col justify-between gap-4 lg:flex-row">
    <div class="flex flex-row gap-[15px]">
      <div class="flex flex-col items-center justify-center">
        <ion-thumbnail slot="start">
          <img
            *ngIf="item.product.subType !== ProductSubType.CUSTOM || item.product.customType !== 'notebook'"
            class="product-image"
            [src]="item.product.pictureUrl || '/assets/images/logo/logo-negro.svg'"
          />
          <app-notebook-preview
            *ngIf="item.product.subType === ProductSubType.CUSTOM && item.product.customType === 'notebook'"
            [optionsSelected]="item.product.customElementsSelected"
          ></app-notebook-preview>
        </ion-thumbnail>
      </div>
      <div class="flex flex-col">
        <div class="info-part flex flex-col">
          <div>
            <div class="item-title">{{ item.product.title }}</div>
          </div>

          <div class="4 flex flex-row items-center" *ngIf="item.product.unitPrice">
            <div class="item-price flex flex-col items-center justify-center">
              {{ item.product.unitPrice.amt | currency: item.product.unitPrice.cur }} UND
            </div>
          </div>
        </div>

        <span class="presale-tag" *ngIf="item.product.presale">Preventa</span>

        <div class="flex flex-col capitalize" *ngIf="item.product.properties">
          <span *ngFor="let prop of formatProperties(item.product.properties); trackBy: trackProperty">
            <span class="font-medium">{{ prop.key }}:</span> {{ prop.value }}
          </span>
        </div>

        <div *ngIf="item.qty > item.product.stock && !item.product.allowSaleNoStock">
          <span class="stock-error" *ngIf="item.product.stock >= 1"
            >Lo sentimos pero solo quedan {{ item.product.stock }} unidades en stock.</span
          >
          <span class="stock-error" *ngIf="item.product.stock < 1"
            >Lo sentimos pero en este momento este producto está agotado.</span
          >
        </div>

        <div *ngIf="item.product.stock === undefined">
          <span class="stock-error">Lo sentimos pero este producto ya no está disponible.</span>
        </div>
      </div>
    </div>

    <div class="flex w-full flex-col justify-center sm:items-center lg:w-1/2 lg:items-end">
      <div class="right-part flex w-full flex-col items-center justify-end gap-5 lg:m-0 lg:flex-row">
        <div class="order-2 w-full items-center lg:order-1">
          <app-qty-stepper
            *ngIf="
              !disableActions &&
              cartService.currentStep < 2 &&
              (item.product.allowSaleNoStock || item.product.stock > 0)
            "
            class="flex-initial"
            [qty]="item.qty"
            [min]="1"
            [showQty]="true"
            [max]="item.product.allowSaleNoStock ? 100 : item.product.stock > 0 ? item.product.stock : 0"
            (changes)="onQtyChange($event)"
            [disabled]="cartService.currentStep >= 2"
          >
          </app-qty-stepper>
        </div>
        <div class="order-1 flex w-full items-center justify-between gap-4 lg:order-2">
          <div class="item-price flex-initial">
            {{ item.qty * item.product.unitPrice?.amt | currency: item.price?.cur }}
          </div>
          <ion-button
            class="flex-initial"
            *ngIf="!disableActions && cartService.currentStep < 2"
            fill="clear"
            color="danger"
            class="delete-button"
            (click)="onDelete(item)"
          >
            <ion-icon src="../../../assets/icon/eliminar.svg"></ion-icon>
          </ion-button>
        </div>
      </div>

      <ion-button
        *ngIf="item.product.customElementsSelected"
        class="view-details-button flex w-fit items-center justify-center gap-[3px]"
        fill="clear"
        size="small"
        (click)="toggleViewDetails()"
      >
        <span>{{ viewDetails ? 'ocultar detalles' : 'ver detalles' }}</span>
        <img [ngClass]="{ '-scale-y-100': viewDetails }" src="../../../assets/icon/flechaAbajo.svg" />
      </ion-button>
    </div>
  </div>

  <div *ngIf="viewDetails" class="notebook-details grid grid-cols-2">
    <span *ngFor="let prop of formattedCustomElements">
      <span class="font-medium">{{ prop.key }}:</span> {{ prop.value }}
    </span>
  </div>
</div>
